<template>
  <b-card>
    <user-add-account
      class="mt-2 pt-75"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import UserAddAccount from './UserAddAccount.vue'

export default {
  components: {
    BCard,
    UserAddAccount,
  },
}
</script>

<style>

</style>
